import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ICardCollection } from '../interfaces/card.interfaces';
import { Cards } from '../models/cards';

@Injectable({
  providedIn: 'root',
})
export class CardDataService {
  private cardData: Cards;

  constructor(private injector: Injector) {
    this.cardData = new Cards();
  }

  get cards(): Cards {
    return this.cardData;
  }

  loadCardData() {
    const http = this.injector.get(HttpClient);

    return forkJoin([
      http.get('assets/config/comreg-cards.json').pipe(tap((data) => (this.cardData.comreg = data as ICardCollection))),

      http.get('assets/config/account-cards.json').pipe(tap((data) => (this.cardData.accounts = data as ICardCollection))),

    ]).toPromise();
  }
}
